import { useNavigate } from 'react-router-dom';

import {
  getAnnotationToolSupervisorPath,
  getAnnotationToolAnnotatorQueuePath,
  getAnnotationToolAdminProjectsPath,
  getAnnotationToolAnnotatorProjectPath,
  getAnnotationToolSupervisorProjectPath,
} from '@verantos-dev/core-annotation-tool';

export interface UseNavOnDashboardResult {
  navigateToAnnotatorQueue: (e: React.MouseEvent) => void;
  navigateToAnnotationSupervisor: (e: React.MouseEvent) => void;
  navigateToAdminProjects: (e: React.MouseEvent) => void;
  navigateToProjects: (e: React.MouseEvent, hasSupervisionBatches: boolean) => void;
}

export const useNavOnDashboard = (): UseNavOnDashboardResult => {
  const navigate = useNavigate();

  const navigateToAnnotatorQueue = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(getAnnotationToolAnnotatorQueuePath());
  };

  const navigateToAnnotationSupervisor = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(getAnnotationToolSupervisorPath());
  };

  const navigateToAdminProjects = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(getAnnotationToolAdminProjectsPath());
  };

  const navigateToProjects = (e: React.MouseEvent, hasSupervisionBatches: boolean) => {
    e.preventDefault();
    if (hasSupervisionBatches) {
      navigate(getAnnotationToolSupervisorProjectPath());
      return;
    }
    navigate(getAnnotationToolAnnotatorProjectPath());
    return;
  };

  return {
    navigateToAnnotatorQueue,
    navigateToAnnotationSupervisor,
    navigateToAdminProjects,
    navigateToProjects,
  };
};
